import { SelfContainedCommand, CommandExecutionContext } from '../../../../types/commands';
import { StandardToolResult, createErrorResult } from '../../../../types/standardToolResults';

export const toolFetchCommand: SelfContainedCommand = {
  id: 'tool_fetch',
  description: '📦 Fetch a full tool result artifact using its reference ID',
  
  schema: {
    parameters: [
      {
        name: 'ref_id',
        type: 'string',
        description: 'The reference ID of the artifact to fetch (e.g., "artifact_12345")',
        required: true,
      },
    ],
  },
  
  examples: {
    good: [
      {
        input: { ref_id: 'artifact_12345' },
        expectedOutput: {
          status: 'success',
          message: 'Successfully fetched artifact.',
          data: { artifactContent: '...' },
          format: 'json',
        },
        description: 'Fetch a previously stored tool result artifact by reference ID.'
      },
    ],
    bad: [
      {
        input: { ref_id: 'invalid_id' },
        error: 'Artifact not found',
        why: 'The provided ref_id does not exist in the artifact store.',
        fix: 'Use a valid ref_id returned in a prior tool result envelope.'
      },
    ],
  },

  handler: async (params: { ref_id: string }, context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { ref_id } = params;

    if (!ref_id) {
      return createErrorResult('Missing ref_id', 'A reference ID must be provided.', 'validation');
    }

    // No-op: artifact fetching not supported in NEW system
    return createErrorResult('Artifact not found', `Artifact fetching not supported in NEW system for ref_id: ${ref_id}`, 'execution');
  },
};
